<template>
  <el-dialog
    class="pop-dialog"
    :visible.sync="dialogVisible"
    :width="width"
    :height="height">
    <slot></slot>
  </el-dialog>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    }
  },
  watch: {
    show (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('update:show', val)
    }
  },
  data () {
    return {
      dialogVisible: false
    }
  }
}
</script>
<style lang="scss">
  .pop-dialog{
    .el-dialog{
      width: fit-content;
      .el-dialog__header{
        padding: 0;
        .el-dialog__headerbtn{
          top: -50px;
          right: -20%;
          width: 40px;
          height: 40px;
          font-size: 24px;
          color: #fff;
          background-color: #606266;
          border-radius: 50%;
          .el-dialog__close{
            font-size: 24px;
            color: #fff;
          }
        }
      }
      .el-dialog__body{
        padding: 0;
        font-size: 0;
        width: 60vw;
      }
    }
  }
</style>
